import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=da069f28&scoped=true"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"
import style0 from "../../components/common/css/Auth.css?vue&type=style&index=0&id=da069f28&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da069f28",
  null
  
)

export default component.exports